import 'toastr/build/toastr.min.css';
import toastr from 'toastr';

// Config Toastr
toastr.options = {
    preventDuplicates: true,
    progressBar: true,
    newestOnTop: true,
    timeOut: 10000,
};

$(document).ready(function () {
    if (window.__TOASTR_MESSAGE__) {  // coming from Laravel
        const { state, message, title } = window.__TOASTR_MESSAGE__;
        toastr[state](message, title);
    }
});
